export default __webpack_public_path__ + "static/media/Trimmer.dc11572d.jpg";